export default __webpack_public_path__ + "static/texture-yellow-dots-02-ec4700f2bece45f04a67b08d9b41b8e3.png";